import React from 'react';

import styled from 'styled-components';

import { INutritionInfo } from '@rbi-ctg/menu';

import { SanityNutritionItem } from './types';

const TableRow = styled.tr`
  align-items: center;
`;

const Name = styled.th`
  text-transform: capitalize;
  white-space: nowrap;
  text-align: left;
  font-weight: normal;
`;

const Value = styled.td`
  text-align: right;
  white-space: nowrap;
`;

type NutritionItemProps = {
  nutritionItem: SanityNutritionItem;
  nutritionInfo: INutritionInfo;
  roundNutritionValue: (val: number) => number;
};

export const NutritionItem: React.FC<NutritionItemProps> = ({
  nutritionInfo,
  nutritionItem,
  roundNutritionValue,
  ...props
}) => {
  const primaryItemValue = nutritionInfo[nutritionItem.nutritionKey ?? ''];
  const primaryItemUnit = nutritionItem.unit?.locale;
  const primaryItemName = nutritionItem.name?.locale;
  if (primaryItemValue === undefined || !primaryItemUnit || !primaryItemName) {
    return null;
  }

  const roundedPrimaryItemValue = roundNutritionValue(primaryItemValue);

  const firstAdditionalItem = nutritionItem.additionalItems?.[0];
  const additionalItemUnit = firstAdditionalItem?.unit?.locale;
  const additionalItemValue = nutritionInfo[firstAdditionalItem?.nutritionKey ?? ''];

  const roundedAdditionalItemValue =
    additionalItemValue !== undefined ? roundNutritionValue(additionalItemValue) : undefined;

  return (
    <TableRow {...props}>
      <Name scope="row">{primaryItemName}</Name>
      <Value>
        <span data-testid="primary-item-nutrition-value">
          {roundedPrimaryItemValue}
          {primaryItemUnit}
        </span>
        {firstAdditionalItem && (
          <span data-testid="additional-item-nutrition-value">
            {' '}
            / {roundedAdditionalItemValue}
            {additionalItemUnit}
          </span>
        )}
      </Value>
    </TableRow>
  );
};
